export default __webpack_public_path__ + "static/media/you-can-do-it-768w.0942c052.png";